import type { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { CLEAR_WARBOX_CONVERSATION_MESSAGES } from '../constants/actions';
import type { TWarboxMessageActionTypes } from '../types';

const getErrorMessage = (error: any) =>
    error?.response?.data?.error ||
    (error instanceof Error
        ? error.message
        : 'No se pudieron vaciar los mensajes');

/**
 * Clears all messages for a conversation.
 * Backend route expected: DELETE /conversation-messages/conversation/:conversationId/clear
 */
export const clearConversationMessages = async (
    dispatch: Dispatch<TWarboxMessageActionTypes>,
    conversationId: string
): Promise<void> => {
    try {
        await ApiV2.delete(
            `/conversation-messages/conversation/${conversationId}/clear`,
            HEADERS()
        );

        dispatch({
            type: CLEAR_WARBOX_CONVERSATION_MESSAGES,
            payload: { conversationId },
        });
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
